import { render, staticRenderFns } from "./EditCouponOverlay.vue?vue&type=template&id=1b938c34"
import script from "./EditCouponOverlay.vue?vue&type=script&lang=js"
export * from "./EditCouponOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports